import { render, staticRenderFns } from "./ClubModule.vue?vue&type=template&id=8e754bc8&scoped=true"
import script from "./ClubModule.vue?vue&type=script&lang=js"
export * from "./ClubModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e754bc8",
  null
  
)

export default component.exports